import { getStore } from "../store/store";
import { SearchScopeKind } from "owa-search-service/lib/data/schema/SearchScope";

/**
 * Returns true when the user has selected the "All mailboxes" scope in the search scope picker.
 */
export default function getIsAllMailboxesScopeSelected(): boolean {
    return getStore().staticSearchScope?.kind === SearchScopeKind.AllMailboxes;
}
